import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import EditIcon from '@material-ui/icons/Edit';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import InputLabel from '@material-ui/core/InputLabel';
import MediaModel from '../../models/media';
import { Button } from '@material-ui/core';

class LzMedia extends React.Component {

    render() {
        const {
            avatar, avatarInitials, altText, imgSrc, contentTypeIcon, fileType, label,
            className, onRemove, onUpload, disabled, hints
        } = this.props;

        const hasMedia = imgSrc && imgSrc !== '';

        return (
            <div style={{ width: 'fit-content', position: 'relative' }}>

                <InputLabel className='lz-label' shrink>{label}</InputLabel>

                {(hasMedia && onRemove && !disabled) &&
                    <IconButton size="small" className="danger"
                        style={{ width: 24, height: 24, position: 'absolute', top: 8, right: -6, zIndex: 99 }}
                        onClick={() => onRemove()}
                    >
                        <RemoveIcon />
                    </IconButton>
                }

                {(onUpload && !disabled) &&
                    <React.Fragment>
                        {hasMedia ?
                            <IconButton size="small" className="success"
                                style={{ width: 24, height: 24, position: 'absolute', bottom: -8, right: -6, zIndex: 99 }}
                                onClick={() => onUpload()}
                            >
                                <EditIcon style={{ fontSize: 16 }} />
                            </IconButton>
                            :
                            <div style={{ paddingTop: 8 }}>
                                {hints && <small style={{ display: 'block', paddingBottom: 4 }}>{hints}</small>}
                                <Button variant="contained" size="small" color="primary" className="gray" onClick={() => onUpload()}>Upload File...</Button>
                            </div>
                        }
                    </React.Fragment>
                }

                {avatar ?
                    <Avatar
                        src={imgSrc}
                        alt={altText}
                        children={avatarInitials}
                        className={className || ''}
                    />
                    :
                    <Card
                        elevation={0}
                        className={className || ''}
                    >
                        {hasMedia &&
                            <a href={imgSrc} target="_blank" rel="noreferrer">
                                <CardMedia
                                    image={imgSrc}
                                    children={fileType === MediaModel.FILE_TYPE_DOCUMENT && contentTypeIcon ? contentTypeIcon : ''}
                                    title={altText}
                                    style={{ height: 120, backgroundSize: 'contain' }}
                                />
                            </a>
                        }
                    </Card>
                }

            </div>
        );
    }

}

export default LzMedia;
